import React from 'react';
import { RouterProvider } from 'react-router-dom';
import Routers from './routes/router';

const App = () => {
  return <RouterProvider router={Routers} />;
};

export default App;
